<template>
  <div id="grid-documento">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Ingresar Producción Diaria</v-toolbar-title
          >
        </v-toolbar>
        <v-container grid-list-xl>
          <v-layout justify-center>
            <v-flex lg4>
              <p>Nivel: {{ this.detail.nivel }}</p>
            </v-flex>
            <v-flex lg4>
              <p>Tipo Prueba: {{ this.detail.tipoPrueba }}</p>
            </v-flex>
            <v-flex lg4>
              <p>
                Region: {{ this.detail.codigoRegion }} -
                {{ this.detail.region }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex lg6>
              <p>Fecha Estimada Inicio: {{ this.detail.fechaInicio }}</p>
            </v-flex>
            <v-flex lg6>
              <p>Fecha Estimada Recepción: {{ this.detail.fechaRecepcion }}</p>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newProgreso()">Nuevo</v-btn>
        </v-card-actions>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <v-layout justify-center>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <div v-if="loading">
              <loading></loading>
            </div>
            <v-data-table
              :headers="headers"
              :items="itemsProgreso"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.fecha }}</td>
                <td class="text-xs-left">{{ props.item.numeroGuia }}</td>
                <td class="text-xs-left">
                  {{ props.item.rutEntrega }}{{ props.item.dvEntrega }}
                </td>
                <td class="text-xs-left">{{ props.item.cajasAEnviar }}</td>
                <v-btn
                  v-if="props.item.filename != null"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Descargar archivo"
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <td v-if="props.item.filename == null">No se programó envío</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
export default {
  name: "FormProgresoDiario",
  components: {
    AlertEmpty,
  },
  props: {
    itemsDocumento: {},
    rowsTable: "",
  },

  data() {
    return {
      loading: true,
      dialog: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Fecha Producción",
          align: "left",
          sortable: false,
        },
        {
          text: "N° Guía",
          sortable: false,
        },
        { text: "Rut Entrega", sortable: false },
        {
          text: "Cajas Despachadas",
          sortable: false,
          value: "fechaEntrega",
        },
        {
          text: "Archivos Cajas",
          sortable: false,
        },
      ],
      itemsProgreso: [],
      detail: "",
    };
  },
  created() {
    this.idSubitem = this.$route.params.idSubitem;
    this.idAcuerdo = this.$route.params.idAcuerdo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadDataProgreso();
    this.detail = this.loadDetailSubitem();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDetailSubitem() {
      this.detail = await this.detailSubitem();
    },
    async loadDataProgreso() {
      this.loading = true;
      this.itemsProgreso = await this.loadProgreso();

      if (this.itemsProgreso.length > 0) {
        // this.alertaEnvios = false;
      } else {
        // this.alertaEnvios = true;
      }
      this.loading = false;
    },
    async detailSubitem() {
      let that = this;
      return await axios
        .get("progreso/" + this.idAcuerdo + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadProgreso() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get("progreso/envios/" + this.idSubitem + "/" + idContrato)
        .then(function (response) {
          console.log(response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async downloadFile(id, filename) {
      let that = this;
      return await axios({
        url: "progreso/download/" + id + "/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    newProgreso() {
      setTimeout(() => {
        this.$router.push({
          name: "ProgresoRegistra",
          params: {
            tipeView: "crear",
            idSubitem: this.idSubitem,
            idAcuerdo: this.idAcuerdo,
          },
        });
      }, 1000);
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoImpresion",
        });
      }, 1000);
    },
  },
};
</script>
